import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import './Internship.css'
import AcademicCommoncrd from '../AcademicCommoncrd/AcademicCommoncrd';
import AcademicBackBtn from '../AcademicBackBtn';

const Internship = ({ setShow }) => {

    const [internInfo, setInternInfo] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.internshipInfo,
            })
            .then((response) => {
                const internDoc = response.data.allInternships.edges[0].node;
                setInternInfo(internDoc);
                window.scrollTo(0, 0)



            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <>
            <section style={{ backgroundImage: `url(${internInfo?.section_bg?.url})` }} className="section-common-info">
                <div className="container">
                    <AcademicBackBtn/>
                    <h3 className="subtitle pt-0 pb-1">{internInfo?.title[0]?.text}</h3>
                    <p className="pt-2 pb-1 body-text">{internInfo?.description[0]?.text}</p>
                    <p className="pt-2  body-text">{internInfo?.description2[0]?.text}</p>

                    <div className="row g-2 py-4">
                        {internInfo?.intern_card?.map(info =>
                            <AcademicCommoncrd
                                info={info}
                                internInfo={true}
                                crdHight={360}
                                XLHight={300}
                            >

                            </AcademicCommoncrd>)
                        }

                    </div>

                    <div className="application-process">
                        <h5 className="appication-title">{internInfo?.subtitle[0]?.text}</h5>
                        <p className="">{internInfo?.sub_descript[0]?.text}</p>
                        <p className="m-0">{internInfo?.link_text} <a target="_blank" href={internInfo?.link1}> Link</a> </p>
                        <p className="">{internInfo?.link1_text}<a target="_blank" href={internInfo?.link2}> Link</a>  </p>
                        <p >{internInfo?.email_text[0]?.text}
                            <a target="_blank" href={"mailto:" + internInfo?.email[0]?.text}>
                                {internInfo?.email[0]?.text}</a>
                        </p>

                    </div>
                </div>
            </section>



        </>


    );
};

export default Internship;



